import { createContext, useContext } from "react";

import { Location } from "react-router";

export const LocationHistoryContext = createContext<Location[] | undefined>(
  undefined,
);

export const useLocationHistory = () => {
  const context = useContext(LocationHistoryContext);
  if (context === undefined) {
    throw new Error(
      "useLocationHistory must be within LocationHistoryProvider",
    );
  }

  return context;
};
